import React, { Component } from 'react';
import 'antd/dist/reset.css';
import { withRouter } from '../../Components/Items'


class Terminos extends Component {

    render() {
        return (
            <div className='registro-carrera-backgorund'>
                <div className="registro-carrera-container">
                    <h1 className="registro-carrera-title">Terminos y Condiciones</h1>
                    <div className="registro-carrera-form">
                        <p>
                            <strong>1. Aceptación de los Términos</strong><br />
                            Al registrarse en la carrera organizada por INTEGRAME DOWN AC a través del sitio web
                            <a href="https://www.todossomosdiferentes.com" target="_blank" rel="noopener noreferrer">
                                www.todossomosdiferentes.com
                            </a>, el usuario acepta los presentes Términos y Condiciones en su totalidad. Si no está de acuerdo con ellos, le solicitamos abstenerse de realizar el registro.
                        </p>
                        <p>
                            <strong>2. Proceso de Registro</strong><br />
                            El registro para la carrera se realizará exclusivamente a través del sitio web
                            <a href="https://www.todossomosdiferentes.com" target="_blank" rel="noopener noreferrer">
                                www.todossomosdiferentes.com
                            </a>. Es responsabilidad del participante proporcionar información correcta y completa durante el proceso de registro. En caso de que se detecte información incorrecta, el comité organizador se reserva el derecho de revocar la premiación y reasignarla al siguiente participante en la clasificación, si corresponde.
                        </p>
                        <p>
                            <strong>3. Formas de Pago</strong><br />
                            El sitio acepta las siguientes modalidades de pago:<br />
                            - Tarjeta de crédito y débito.<br />
                            - Transferencia bancaria.<br />
                            - Pago en efectivo en los puntos designados por la organización.<br />
                            Es responsabilidad del participante verificar que el pago se haya realizado correctamente. El registro solo se considerará completo una vez que el pago haya sido confirmado.
                        </p>
                        <p>
                            <strong>4. Política de Reembolsos</strong><br />
                            No se otorgarán reembolsos bajo ninguna circunstancia, salvo en los casos en que la organización cancele el evento por causas mayores. En ese caso, se comunicará a los participantes el procedimiento para solicitar el reembolso.
                        </p>
                        <p>
                            <strong>5. Responsabilidad por Accidentes</strong><br />
                            El comité organizador no se hace responsable por los accidentes que puedan sufrir los participantes durante la carrera, ya que estos se consideran riesgos deportivos inherentes a la actividad. Es responsabilidad de cada participante contar con las condiciones físicas y de salud necesarias para participar.
                        </p>
                        <p>
                            <strong>6. Derechos de Imagen</strong><br />
                            Al registrarse, el participante autoriza a INTEGRAME DOWN AC a utilizar fotos, videos y cualquier material audiovisual tomado durante el evento para fines de promoción, sin que esto implique compensación económica alguna.
                        </p>
                        <p>
                            <strong>7. Premiación</strong><br />
                            Los ganadores deberán acreditar su identidad y proporcionar información verídica para recibir los premios.

                            En caso de detectarse irregularidades o datos falsos en el registro, el comité organizador tendrá la facultad de descalificar al participante y reasignar el premio al siguiente en la clasificación.

                        </p>
                        <p>
                            <strong>8. Modificaciones y Cancelaciones</strong><br />
                            INTEGRAME DOWN AC se reserva el derecho de modificar la fecha, horario o cualquier aspecto relacionado con la organización del evento por causas de fuerza mayor. Estas modificaciones serán notificadas oportunamente a los participantes a través de los medios oficiales.
                        </p>
                        <p>
                            <strong>9. Protección de Datos Personales</strong><br />
                            Los datos proporcionados por los participantes serán tratados conforme a la legislación vigente en materia de protección de datos personales. Para más información, consulte nuestra Política de Privacidad en <a href="https://www.todossomosdiferentes.com" target="_blank" rel="noopener noreferrer">
                                www.todossomosdiferentes.com
                            </a>.
                        </p>
                        <p>
                            <strong>10. Contacto</strong><br />
                            Para dudas o aclaraciones, puede comunicarse con el equipo organizador a través del correo electrónico contacto@todossomosdiferentes.com.
                        </p>
                        <p>
                            <strong>11. Aceptación Final</strong><br />
                            Al completar el proceso de registro, el participante declara haber leído y aceptado estos Términos y Condiciones, así como estar consciente de las responsabilidades y riesgos asociados con la participación en la carrera.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Terminos);